import data from './text.json'
import Resources from './views/resources'
import Monitoring from './views/monitoring'
import Plans from './views/plans'
import ApplyVoucher from './views/apply-voucher'
import CustomerSettings from './views/customer-settings'
import ChangePassword from './views/change-password'
import ChangeUsername from './views/change-username'
import ConfirmCode from './views/confirm-code'
import Services from './views/services'
import NotificationChannels from './views/notifications'
import NotFoundPage from './views/not-found'
import DeleteAccount from './views/delete-account'
import Subscription from './views/subscription'
import Subscriptions from './views/billings'
import PaymentMethods from './views/payment-methods'
import Automations from './views/automations'
import AutomationDesigner from './views/automation-designer'
import Members from './views/members'
import Jobs from './views/jobs'
import Job from './views/job'
import Teams from './views/teams'
import Integrations from './views/integrations'
import ResourceIntegrations from './views/resource-integrations'
import RedeemCoupon from './views/redeem-coupon'
import Statuspages from './views/statuspages'
import StatuspageSubscriptions from './views/statuspages/Subscriptions'
import CreateEditStatuspage from './views/statuspages/CreateEditStatuspage'
import Incidents from './views/incidents'
import Rulesets from './views/rulesets'
import OnCallScheduling from './views/on-call-scheduling'
import CreateEditRuleset from './views/rulesets/CreateEditRuleset'
import ServerMonitoring from './views/server-monitoring'
import CreateEditServerResource from './views/server-monitoring/CreateEditServerResource'
import {isSelfHosted} from './utils/newFeature'
import Usage from './views/usage'
import ServerResourceDashboard from './views/server-monitoring/ServerResourceDashboard'
import JobEvents from './views/jobEvents'

const routeItem = (title, path, component) => {
    return {
        title,
        path,
        component,
        isSame: function(path) {
            return path === this.path
        },
        containsId: function(path) {
            const basePath = this.path.split('/')[1]
            const isUUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(path?.[2])
            return isUUID && basePath === path?.[1]
        }
    }
}

const routes = {
    resources: routeItem(data.ping_home_console_resources, '/', Resources),
    server_monitoring: routeItem(data.ping_home_console_server_monitoring, '/server-monitoring', ServerMonitoring),
    server_resource: routeItem(data.ping_home_console_server_monitoring, '/server-monitoring/:id', ServerResourceDashboard),
    create_server_monitoring: routeItem(data.ping_home_console_server_monitoring_create, '/server-monitoring/create', CreateEditServerResource),
    edit_server_monitoring: routeItem(data.ping_home_console_server_monitoring_edit, '/server-monitoring/update/:id', CreateEditServerResource),
    monitoring: routeItem(data.ping_home_console_monitoring, '/monitoring/:id', Monitoring),
    plans: routeItem(data.ping_home_console_plans, '/plans/', Plans),
    usage: routeItem(data.ping_home_console_usage, '/usage/', Usage),
    apply_voucher: routeItem(data.ping_home_console_apply_voucher, '/apply-voucher', ApplyVoucher),
    redeem_coupon: !isSelfHosted() && routeItem(data.ping_home_console_redeem_coupon, '/redeem-coupon', RedeemCoupon),
    settings: routeItem(data.ping_home_console_settings, '/customer-settings', CustomerSettings),
    change_password: routeItem(data.ping_home_console_change_password, '/change-password', ChangePassword),
    change_username: routeItem(data.ping_home_console_change_username, '/change-username', ChangeUsername),
    confirm_code: routeItem(data.ping_home_console_confirm_code, '/confirm-code', ConfirmCode),
    delete_account: routeItem(data.ping_home_console_delete_account, '/delete-account', DeleteAccount),
    services: routeItem(data.ping_home_console_services, '/services', Services),
    notifications: routeItem(data.ping_home_console_personal_channels, '/notifications/personal', NotificationChannels),
    integrations: routeItem(data.ping_home_console_integrations, '/integrations', Integrations),
    oauth_integration: routeItem(data.ping_home_console_integrations, '/integration/oauth/authorize', Integrations),
    resource_integrations: routeItem(data.ping_home_console_resource_integrations, '/resource/:id/integrations', ResourceIntegrations),
    team_channels: routeItem(data.ping_home_console_team_channels, '/notifications/team', NotificationChannels),
    subscription_success: !isSelfHosted() && routeItem(data.ping_home_console_subscription, '/subscription/success', Subscription),
    subscription_cancel: !isSelfHosted() && routeItem(data.ping_home_console_subscription, '/subscription/cancel', Subscription),
    subscription_update_success: !isSelfHosted() && routeItem(data.ping_home_console_subscription, '/subscription/update/success', Subscription),
    subscription_update_cancel: !isSelfHosted() && routeItem(data.ping_home_console_subscription, '/subscription/update/cancel', Subscription),
    subscriptions: !isSelfHosted() && routeItem(data.ping_home_console_subscriptions, '/subscriptions', Subscriptions),
    payment_methods: !isSelfHosted() && routeItem(data.ping_home_console_payment_methods, '/payment-methods', PaymentMethods),
    teams: routeItem(data.ping_home_console_teams, '/teams', Teams),
    members: routeItem(data.ping_home_console_members, `/teams/:teamId/members`, Members),
    automations: !isSelfHosted() && routeItem(data.ping_home_console_automations, '/automation', Automations),
    automation_designer: routeItem(data.ping_home_console_automation_designer, '/automation/:id/designer', AutomationDesigner),
    jobs: routeItem(data.ping_home_console_jobs, '/jobs', Jobs),
    job_events: routeItem(data.ping_home_console_job_events, '/events', JobEvents),
    job: routeItem(data.ping_home_console_heartbeats, '/jobs/:id', Job),
    statuspages: routeItem(data.ping_home_console_statuspages, '/status-pages', Statuspages),
    statuspage_subscriptions: routeItem(data.ping_home_console_statuspage_subscriptions, '/status-page-subscriptions', StatuspageSubscriptions),
    create_statuspage: routeItem(data.ping_home_console_create_statuspage, '/status-pages/create', CreateEditStatuspage),
    edit_statuspage: routeItem(data.ping_home_console_update_statuspage, '/status-pages/:id', CreateEditStatuspage),
    incidents: routeItem(data.ping_home_console_incidents, '/incidents', Incidents),
    rulesets: routeItem(data.ping_home_console_rulesets, '/rulesets', Rulesets),
    create_ruleset: routeItem(data.ping_home_console_create_ruleset, '/rulesets/create', CreateEditRuleset),
    edit_ruleset: routeItem(data.ping_home_console_update_ruleset, '/rulesets/:id', CreateEditRuleset),
    not_found: routeItem(data.ping_home_console_not_found, '/not-found', NotFoundPage),
    on_call_scheduling:  routeItem(data.ping_home_on_call_scheduling, '/on-call-scheduling', OnCallScheduling),
    unhandled_route: routeItem(data.ping_home_console_not_found, '/*', NotFoundPage)

}

const routeArr = Object.values(routes)

export {
    routes,
    routeArr
}
